export enum ExamBadgeType {
  ACADEMIC_WR_2 = 'academic_wr_2.png',
  ACADEMIC_WR_3 = 'academic_wr_3.png',
  ACADEMIC_WR = 'academic_wr.png',
  ACCOUNT_1 = 'accounting_1.png',
  ACCOUNT_2 = 'accounting_2.png',
  ACCOUNT_3 = 'accounting_3.png',
  ACTIONSCRIPT_3_1 = 'actionscript-3-1.png',
  ACTIONSCRIPT_3_2 = 'actionscript-3-2.png',
  ACTIONSCRIPT_3_3 = 'actionscript-3-3.png',
  ADMIN = 'admin.png',
  ADOBE_FLEX = 'adobe_flex.png',
  ADODOTNET_1 = 'adodotnet-1.png',
  ADODOTNET_2 = 'adodotnet-2.png',
  ADODOTNET_3 = 'adodotnet-3.png',
  ADSENSE_1 = 'ADsense_1.png',
  ADSENSE_2 = 'ADsense_2.png',
  ADSENSE_3 = 'ADsense_3.png',
  ADV_LOGO_1 = 'adv_logic_1.png',
  ADWORDS_1 = 'ADwords_1.png',
  ADWORDS_2 = 'ADwords_2.png',
  ADWORDS_3 = 'ADwords_3.png',
  ADWORDS_API_1 = 'adwords-api-1.png',
  ADWORDS_API_2 = 'adwords-api-2.png',
  ADWORDS_API_3 = 'adwords-api-3.png',
  AI_CS5_1 = 'ai-cs5-1.png',
  AI_CS5_2 = 'ai-cs5-2.png',
  AI_CS5_3 = 'ai-cs5-3.png',
  AI_TRAINING = 'ai_training.png',
  AI = 'ai.png',
  AJAX_1 = 'AJAX_1.png',
  ALGORITHMS_1 = 'algorithms_1.png',
  ALGORITHMS_2 = 'algorithms_2.png',
  ALGORITHMS_3 = 'algorithms_3.png',
  ANALOG_ELECTRONICS_1 = 'Analog-Electronics_1.png',
  ANALOG_ELECTRONICS_2 = 'Analog-Electronics_2.png',
  ANALOG_ELECTRONICS_3 = 'Analog-Electronics_3.png',
  ANDROID_1 = 'android_1.png',
  ANDROID_2 = 'android_2.png',
  ANDROID_3 = 'android_3.png',
  ANT_1 = 'ant-1.png',
  ANT_2 = 'ant-2.png',
  ANT_3 = 'ant-3.png',
  APACHE_1 = 'apache-1.png',
  APACHE_2 = 'apache-2.png',
  APACHE_3 = 'apache-3.png',
  APICONTEST = 'apicontest.png',
  APPLESCRIPT_1 = 'applescript-1.png',
  APPLESCRIPT_2 = 'applescript-2.png',
  APPLESCRIPT_3 = 'applescript-3.png',
  ARROWPLUS = 'arrowplus.png',
  ASP_1 = 'asp_1.png',
  ASP_2 = 'asp_2.png',
  ASP_3 = 'asp_3.png',
  ATOMPUB_1 = 'atompub-1.png',
  AUTHOR_1 = 'author_1.png',
  AUTHOR_2 = 'author_2.png',
  AUTHOR_3 = 'author_3.png',
  AUTOCAD2010 = 'AutoCAD2010.png',
  AWS = 'AWS.png',
  BADGE_2ND_TROPHY2 = 'badge-2nd-trophy2.png',
  BADGE_2ND_TSHIRT2 = 'badge-2nd-tshirt2.png',
  BADGE_3RD_TROPHY2 = 'badge-3rd-trophy2.png',
  BADGE_3RD_TSHIRT2 = 'badge-3rd-tshirt2.png',
  BADGE_PEOPLESCHOICE = 'badge-peopleschoice.png',
  BADGE_TROPHY2 = 'badge-trophy2.png',
  BADGE_TSHIRT2 = 'badge-tshirt2.png',
  BEST_DESIGN_2013 = 'best-design-2013.png',
  BLACKBERRY_2 = 'blackberry-2.png',
  BLACKBERRY_3 = 'blackberry-3.png',
  BLACKBERRY = 'blackberry.png',
  BLOGGER_API_1 = 'blogger-api-1.png',
  BLOGGER_API_2 = 'blogger-api-2.png',
  BLOGGER_API_3 = 'blogger-api-3.png',
  BLOGGING_1 = 'blogging-1.png',
  BLOGGING_2 = 'blogging-2.png',
  BLOGGING_3 = 'blogging-3.png',
  BUG_SQUISHER = 'bug-squisher.png',
  C_1 = 'C_1.png',
  C_2 = 'C_2.png',
  C_3 = 'C_3.png',
  C_PLUSPLUS_PROG_1 = 'c-plusplus-prog-1.png',
  C_PLUSPLUS_PROG_2 = 'c-plusplus-prog-2.png',
  C_PLUSPLUS_PROG_3 = 'c-plusplus-prog-3.png',
  C_PROG_1 = 'c-prog-1.png',
  C_PROG_2 = 'c-prog-2.png',
  C_PROG_3 = 'c-prog-3.png',
  C_SHARP_PROG_1 = 'c-sharp-prog-1.png',
  C_SHARP_PROG_2 = 'c-sharp-prog-2.png',
  C_SHARP_PROG_3 = 'c-sharp-prog-3.png',
  CGI_1 = 'cgi-1.png',
  CGI_2 = 'cgi-2.png',
  CGI_3 = 'cgi-3.png',
  CHASH_PROG_1 = 'cHash-prog-1.png',
  CHASH_PROG_2 = 'cHash-prog-2.png',
  CHASH_PROG_3 = 'cHash-prog-3.png',
  CIRCUIT_1 = 'Circuit_1.png',
  CIRCUIT_DESIGN = 'circuit-design.png',
  CLOUD_COMP_1 = 'cloud-comp-1.png',
  CLOUD_COMP_2 = 'cloud-comp-2.png',
  CLOUD_COMP_3 = 'cloud-comp-3.png',
  COBOL = 'cobol.png',
  COCOA_1 = 'Cocoa_1.png',
  COLDFUSION = 'coldfusion.png',
  COMP_SEC = 'comp_sec.png',
  COMP_SEC2 = 'comp_sec2.png',
  COMP_SEC3 = 'comp_sec3.png',
  COMPILER_DESIGN = 'compiler_design.png',
  COMPUTER_SECURITY_1 = 'computer_security_1.png',
  COMPUTER_SECURITY_2 = 'computer_security_2.png',
  COMPUTER_SECURITY_3 = 'computer_security_3.png',
  COMPUTERGRAPHICS_1 = 'ComputerGraphics_1.png',
  COMPUTERGRAPHICS_2 = 'ComputerGraphics_2.png',
  COMPUTERGRAPHICS_3 = 'ComputerGraphics_3.png',
  CPLUSPLUS_1 = 'cplusplus_1.png',
  CPLUSPLUS_2 = 'cplusplus_2.png',
  CPLUSPLUS_3 = 'cplusplus_3.png',
  CSHARP_1 = 'csharp_1.png',
  CSHARP_2 = 'csharp_2.png',
  CSHARP_3 = 'csharp_3.png',
  CSS_1 = 'css_1.png',
  CUDA = 'CUDA.png',
  CUSTOMERSERVICE_1 = 'CustomerService_1.png',
  CUSTOMERSERVICE_2 = 'CustomerService_2.png',
  CUSTOMERSERVICE_3 = 'CustomerService_3.png',
  DANISH_1 = 'danish-1.png',
  DANISH_2 = 'danish-2.png',
  DANISH_3 = 'danish-3.png',
  DANISH_ENG = 'danish-eng.png',
  DART_1 = 'dart-1.png',
  DART_2 = 'dart-2.png',
  DART_3 = 'dart-3.png',
  DATA_ENTRY_1 = 'data_entry_1.png',
  DATASTRUCTURES = 'datastructures.png',
  DEPLHI_1 = 'Delphi_1.png',
  DIGITAL_IMG_PROC = 'digital-img-proc.png',
  DIGITALELECTRONICS_1 = 'DigitalElectronics_1.png',
  DIGITALELECTRONICS_2 = 'DigitalElectronics_2.png',
  DIGITALELECTRONICS_3 = 'DigitalElectronics_3.png',
  DNS_BIND_1 = 'dns-bind-1.png',
  DNS_BIND_2 = 'dns-bind-2.png',
  DNS_BIND_3 = 'dns-bind-3.png',
  DOMINO_DES_1 = 'domino-des-1.png',
  DOMINO_DES_2 = 'domino-des-2.png',
  DOMINO_DES_3 = 'domino-des-3.png',
  DONANZA = 'donanza.png',
  DOTNET_1 = 'dotnet_1.png',
  DOTNET_2 = 'dotnet_2.png',
  DOTNET_3 = 'dotnet_3.png',
  DOTNETNKE_1 = 'dotnetnuke-1.png',
  DOTNETNKE_2 = 'dotnetnuke-2.png',
  DOTNETNKE_3 = 'dotnetnuke-3.png',
  DREAMWEAVER_1 = 'dreamweaver_1.png',
  DREAMWEAVER_2 = 'dreamweaver_2.png',
  DREAMWEAVER_3 = 'dreamweaver_3.png',
  DRUPAL_1 = 'Drupal_1.png',
  DSP = 'dsp.png',
  DUTCH_1 = 'dutch-1.png',
  DUTCH_2 = 'dutch-2.png',
  DUTCH_3 = 'dutch-3.png',
  DUTCH_ENG = 'dutch-eng.png',
  EMBEDDED_SYS = 'embedded-sys.png',
  EMPLOYER_ORIENTATION = 'employer_orientation.png',
  ENGLISH_1 = 'english_1.png',
  ENGLISH_2 = 'english_2.png',
  ENGLISH_3 = 'english_3.png',
  ENGLISH_LANGUAGE01 = 'English-Language01.png',
  ENGLISH_LANGUAGE02 = 'English-Language02.png',
  ENGLISH_LANGUAGE03 = 'English-Language03.png',
  ERRORCHECKING_1 = 'errorchecking_1.png',
  ERRORCHECKING_2 = 'errorchecking_2.png',
  ERRORCHECKING_3 = 'errorchecking_3.png',
  ETHERNET_ADMIN_1 = 'ethernet-admin-1.png',
  ETHERNET_ADMIN_2 = 'ethernet-admin-2.png',
  ETHERNET_ADMIN_3 = 'ethernet-admin-3.png',
  EUFREELANCE = 'eufreelance.png',
  FACEBOOK_API_1 = 'facebook-api-1.png',
  FACEBOOK_API_2 = 'facebook-api-2.png',
  FACEBOOK_API_3 = 'facebook-api-3.png',
  FACEBOOKDEV = 'facebookdev.png',
  FACTOR_1 = 'factor-1.png',
  FACTOR_2 = 'factor-2.png',
  FACTOR_3 = 'factor-3.png',
  FASTCGI_1 = 'fastcgi-1.png',
  FASTCGI_2 = 'fastcgi-2.png',
  FASTCGI_3 = 'fastcgi-3.png',
  FILIPINO_1 = 'filipino-1.png',
  FILIPINO_2 = 'filipino-2.png',
  FILIPINO_3 = 'filipino-3.png',
  FILIPINO_ENG = 'filipino-eng.png',
  FIREWORKS_1 = 'fireworks_1.png',
  FIREWORKS_2 = 'fireworks_2.png',
  FIREWORKS_3 = 'fireworks_3.png',
  FLASH_1 = 'flash_1.png',
  FLASH_2 = 'flash_2.png',
  FLASH_3 = 'flash_3.png',
  FLASH_CS5_1 = 'flash-cs5-1.png',
  FLASH_CS5_2 = 'flash-cs5-2.png',
  FLASH_CS5_3 = 'flash-cs5-3.png',
  FOR_GAF01 = 'for_GAF01.png',
  FOR_GAF02 = 'for_GAF02.png',
  FOR_EMPLOYER = 'for-employer.png',
  FOR_FREELANCER = 'for-freelancer.png',
  FORTRAN_1 = 'fortran-1.png',
  FORTRAN_2 = 'fortran-2.png',
  FORTRAN_3 = 'fortran-3.png',
  FOUNDATION_FREELANCERS_NET = 'freelancers-badge.png',
  FOUNDATION_SHAREHOLDER = 'foundation_shareholder.png',
  FREELANCER_ORIENTATION = 'freelancer_orientation.png',
  FREELANCER_BLACK = 'freelancer-black.png',
  FREELANCER_WHITE = 'freelancer-white.png',
  FREELANCERDE = 'freelancerde.png',
  FREEMARKET_FM = 'Freemarket-FM.png',
  FRENCH_1 = 'french-1.png',
  FRENCH_2 = 'french-2.png',
  FRENCH_3 = 'french-3.png',
  FRN_ENG = 'frn-eng.png',
  GAAP = 'GAAP.png',
  GAME_PHYSICS_1 = 'game-physics-1.png',
  GAME_PHYSICS_2 = 'game-physics-2.png',
  GAME_PHYSICS_3 = 'game-physics-3.png',
  GENERAL_ORIENTATION = 'general_orientation.png',
  GER_ENG = 'ger-eng.png',
  GERMAN_1 = 'german-1.png',
  GERMAN_2 = 'german-2.png',
  GERMAN_3 = 'german-3.png',
  GOOGLE_WEBMASTER_CENTRAL_1 = 'Google_Webmaster_Central_1.png',
  Google_Website_Optimizer_1 = 'Google_Website_Optimizer_1.png',
  GOOGLE_ANALYTICS = 'google-analytics.png',
  GOOGLE_APP_ENGINE = 'google-app-engine.png',
  GOOGLE_APPS_SCRIPT_1 = 'google-apps-script-1.png',
  GOOGLE_APPS_SCRIPT_2 = 'google-apps-script-2.png',
  GOOGLE_APPS_SCRIPT_3 = 'google-apps-script-3.png',
  GOOGLE_CHECKOUT_1 = 'google-checkout-1.png',
  GOOGLE_CHECKOUT_2 = 'google-checkout-2.png',
  GOOGLE_CHECKOUT_3 = 'google-checkout-3.png',
  GOOGLE_CLOUD_STORAGE_1 = 'google-cloud-storage-1.png',
  GOOGLE_CLOUD_STORAGE_2 = 'google-cloud-storage-2.png',
  GOOGLE_CLOUD_STORAGE_3 = 'google-cloud-storage-3.png',
  GOOGLE_CUSTOM_SEARCH_1 = 'google-custom-search-1.png',
  GOOGLE_CUSTOM_SEARCH_2 = 'google-custom-search-2.png',
  GOOGLE_CUSTOM_SEARCH_3 = 'google-custom-search-3.png',
  GOOGLE_DRIVE_1 = 'google-drive-1.png',
  GOOGLE_DRIVE_2 = 'google-drive-2.png',
  GOOGLE_DRIVE_3 = 'google-drive-3.png',
  GOOGLE_FEED_API = 'google-feed-api.png',
  GOOGLE_MAPS_API_1 = 'google-maps-api-1.png',
  GOOGLE_MAPS_API_2 = 'google-maps-api-2.png',
  GOOGLE_MAPS_API_3 = 'google-maps-api-3.png',
  GOOGLE_STORAGE_1 = 'google-storage-1.png',
  GOOGLE_STORAGE_2 = 'google-storage-2.png',
  GOOGLE_STORAGE_3 = 'google-storage-3.png',
  GOOGLE_W_C = 'google-w-c.png',
  GOOGLEANALYTICS_1 = 'GoogleAnalytics_1.png',
  GOOGLEANALYTICS_2 = 'GoogleAnalytics_2.png',
  GOOGLEANALYTICS_3 = 'GoogleAnalytics_3.png',
  GOOGLECHECKOUT_API_1 = 'googlecheckout-api-1.png',
  GOOGLECHECKOUT_API_2 = 'googlecheckout-api-2.png',
  GOOGLECHECKOUT_API_3 = 'googlecheckout-api-3.png',
  GOOGLEWAVE = 'googlewave.png',
  GRAMMAR_1 = 'grammar_1.png',
  GRAMMAR_2 = 'grammar_2.png',
  GRAMMAR_3 = 'grammar_3.png',
  HASKELL_1 = 'haskell-1.png',
  HASKELL_2 = 'haskell-2.png',
  HASKELL_3 = 'haskell-3.png',
  HTML_1 = 'html_1.png',
  HTML_2 = 'html_2.png',
  HTML_3 = 'html_3.png',
  HTML_BASIC_2 = 'html-basic-2.png',
  HTML_BASIC_3 = 'html-basic-3.png',
  HTML4 = 'html4.png',
  HTML5_BASIC_1 = 'html5-basic-1.png',
  HTML5_GEOLOCATION_1 = 'html5-geolcation-1.png',
  HTML5_GEOLOCATION_2 = 'html5-geolocation-2.png',
  HTML5_GEOLOCATION_3 = 'html5-geolocation-3.png',
  HTML5_IMPACT_1 = 'html5-impact-1.png',
  HTML5_MEDIA_1 = 'html5-media-1.png',
  HTML5_MEDIA_2 = 'html5-media-2.png',
  HTML5_WEBSOCKETS_1 = 'html5-websockets-1.png',
  HTML5 = 'html5.png',
  HTTP = 'http.png',
  ILLUSTRATOR_1 = 'illustrator_1.png',
  ILLUSTRATOR_2 = 'illustrator_2.png',
  ILLUSTRATOR_3 = 'illustrator_3.png',
  IMPACT_1 = 'impact-1.png',
  IMPACT_2 = 'impact-2.png',
  IMPACT_3 = 'impact-3.png',
  INDESIGN_1 = 'indesign_1.png',
  INDESIGN_2 = 'indesign_2.png',
  INDESIGN_3 = 'indesign_3.png',
  INDONESIAN_1 = 'indonesian-1.png',
  INDONESIAN_2 = 'indonesian-2.png',
  INDONESIAN_3 = 'indonesian-3.png',
  INDONESIAN_ENG = 'indonesian-eng.png',
  IPHONE_1 = 'iphone_1.png',
  IPHONE_2 = 'iphone_2.png',
  IPHONE_3 = 'iphone_3.png',
  IPHONE_DEVELOPMENT_1 = 'iPhone_Development_1.png',
  IPHONE_DEVELOPMENT_2 = 'iPhone_Development_2.png',
  IPHONE_DEVELOPMENT_3 = 'iPhone_Development_3.png',
  ISO9001 = 'iso9001.png',
  ITALIAN_1 = 'italian-1.png',
  ITALIAN_2 = 'italian-2.png',
  ITALIAN_3 = 'italian-3.png',
  ITALIAN_ENG = 'italian-eng.png',
  JAVA_1 = 'java_1.png',
  JAVA_2 = 'java_2.png',
  JAVA_3 = 'java_3.png',
  JAVA_EE_6_1 = 'java-ee-6-1.png',
  JAVA_EE_6_2 = 'java-ee-6-2.png',
  JAVA_EE_6_3 = 'java-ee-6-3.png',
  JAVASCRIPT_1 = 'javascript_1.png',
  JAVASCRIPT_2 = 'javascript_2.png',
  JAVASCRIPT_3 = 'javascript_3.png',
  JOOMLA_1 = 'joomla-1.png',
  JOOMLA_2 = 'joomla-2.png',
  JOOMLA_3 = 'joomla-3.png',
  JQUERY_1 = 'jquery-1.png',
  JQUERY_2 = 'jquery-2.png',
  JQUERY_3 = 'jquery-3.png',
  KERBEROS1 = 'kerberos1.png',
  KERBEROS2 = 'kerberos2.png',
  KERBEROS3 = 'kerberos3.png',
  LEX_YACC_1 = 'lex-yacc-1.png',
  LEX_YACC_2 = 'lex-yacc-2.png',
  LEX_YACC_3 = 'lex-yacc-3.png',
  LIMEEXCHANGE = 'limeexchange.png',
  LINQ_1 = 'linq-1.png',
  LINQ_2 = 'linq-2.png',
  LINQ_3 = 'linq-3.png',
  LINQ = 'linq.png',
  LINUX_1 = 'linux_1.png',
  LINUX_2 = 'linux_2.png',
  LINUX_3 = 'linux_3.png',
  LINUX_KERNEL_1 = 'Linux_Kernel_1.png',
  LINUX_KERNEL_2 = 'Linux_Kernel_2.png',
  LINUX_KERNEL_3 = 'Linux_Kernel_3.png',
  LISP = 'lisp.png',
  LOGO_1 = 'logo_1.png',
  LOGO_2 = 'logo_2.png',
  LOGO_3 = 'logo_3.png',
  LOGO_G = 'logo-g.png',
  LOGO_M = 'logo-m.png',
  LOGO_S = 'logo-s.png',
  LOTUS_DOMINO_ADMIN_1 = 'lotus-domino-admin-1.png',
  LOTUS_DOMINO_ADMIN_2 = 'lotus-domino-admin-2.png',
  LOTUS_DOMINO_ADMIN_3 = 'lotus-domino-admin-3.png',
  LOTUS_FORMULA_LANGUAGE_1 = 'lotus-formula-language-1.png',
  LOTUS_FORMULA_LANGUAGE_2 = 'lotus-formula-language-2.png',
  LOTUS_FORMULA_LANGUAGE_3 = 'lotus-formula-language-3.png',
  LOTUS_NOTE_USER_1 = 'lotus-notes_user-1.png',
  LOTUS_NOTE_USER_2 = 'lotus-notes_user-2.png',
  LOTUS_NOTE_USER_3 = 'lotus-notes_user-3.png',
  LOTUSSCRIPT_1 = 'lotusscript-1.png',
  LOTUSSCRIPT_2 = 'lotusscript-2.png',
  LOTUSSCRIPT_3 = 'lotusscript-3.png',
  MACOS_1 = 'macOS_1.png',
  MAGENTO_1 = 'Magento_1.png',
  MAGENTO_2 = 'Magento_2.png',
  MAGENTO_3 = 'Magento_3.png',
  MARKETER_1 = 'marketer_1.png',
  MARKETER_2 = 'marketer_2.png',
  MARKETER_3 = 'marketer_3.png',
  MASTER_GRAPHIC_DESIGNER = 'master_graphic_designer.png',
  MAYA_1 = 'maya_1.png',
  MAYA_2 = 'maya_2.png',
  MAYA_3 = 'maya_3.png',
  MS_AZURE_2 = 'ms-azure-2.png',
  MS_AZURE_3 = 'ms-azure-3.png',
  MS_AZURE = 'ms-azure.png',
  MS_PP_2010_1 = 'ms-pp-2010-1.png',
  MS_PP_2010_2 = 'ms-pp-2010-2.png',
  MS_PP_2010_3 = 'ms-pp-2010-3.png',
  MS_PUBLISHER_2010_1 = 'ms-publisher-2010-1.png',
  MS_PUBLISHER_2010_2 = 'ms-publisher-2010-2.png',
  MS_PUBLISHER_2010_3 = 'ms-publisher-2010-3.png',
  MSACCESS_1 = 'msaccess-1.png',
  MSACCESS_2 = 'msaccess-2.png',
  MSACCESS_3 = 'msaccess-3.png',
  MSPROJECT_1 = 'msproject-1.png',
  MSPROJECT_2 = 'msproject-2.png',
  MSPROJECT_3 = 'msproject-3.png',
  MYSQL_1 = 'mysql-1.png',
  MYSQL_2 = 'mysql-2.png',
  MYSQL_3 = 'mysql-3.png',
  NET_PROG_1 = 'net-prog-1.png',
  NET_PROG_2 = 'net-prog-2.png',
  NET_PROG_3 = 'net-prog-3.png',
  NGINX_1 = 'nginx-1.png',
  NGINX_2 = 'nginx-2.png',
  NGINX_3 = 'nginx-3.png',
  NOR_ENG = 'nor-eng.png',
  NORWEG_1 = 'norweg-1.png',
  NORWEG_2 = 'norweg-2.png',
  NORWEG_3 = 'norweg-3.png',
  NTL_BADGE = 'ntl-badge.png',
  NUBELO = 'nubelo.png',
  NUMERACY_1 = 'numeracy_1.png',
  OAUTH_1 = 'oauth-1.png',
  OAUTH_2 = 'oauth-2.png',
  OAUTH_3 = 'oauth-3.png',
  OAUTH_V2_1 = 'oauth-v2-1.png',
  OAUTH_V2_2 = 'oauth-v2-2.png',
  OAUTH_V2_3 = 'oauth-v2-3.png',
  OBJ_C_1 = 'obj-c-1.png',
  OBJ_C_2 = 'obj-c-2.png',
  OBJ_C_3 = 'obj-c-3.png',
  ODATA_1 = 'odata-1.png',
  OPENGL_1 = 'OpenGL_1.png',
  OPENSOCIAL = 'opensocial.png',
  OPENSSL_1 = 'openssl-1.png',
  OPENSSL_2 = 'openssl-2.png',
  OPENSSL_3 = 'openssl-3.png',
  OPENSTACK_1 = 'openstack-1.png',
  OPENSTACK_2 = 'openstack-2.png',
  OPENSTACK_3 = 'openstack-3.png',
  ORACLE10G_1 = 'oracle10g_1.png',
  ORACLE10G_2 = 'oracle10g_2.png',
  ORACLE10G_3 = 'oracle10g_3.png',
  ORACLE10G = 'oracle10g.png',
  ORACLESQL_1 = 'oraclesql-1.png',
  ORACLESQL_2 = 'oraclesql-2.png',
  ORACLESQL_3 = 'oraclesql-3.png',
  PAPERVISION3D = 'papervision3d.png',
  PAYPALAPI_1 = 'PaypalAPI_1.png',
  PERL5_1 = 'Perl5_1.png',
  PERL5_2 = 'Perl5_2.png',
  PERL5_3 = 'Perl5_3.png',
  PHONEGAP_1 = 'phonegap-1.png',
  PHONEGAP_2 = 'phonegap-2.png',
  PHONEGAP_3 = 'phonegap-3.png',
  PHP_1 = 'php_1.png',
  PHP_2 = 'php_2.png',
  PHP_3 = 'php_3.png',
  PHP5_1 = 'php5-1.png',
  PHP5_2 = 'php5-2.png',
  PHP5_3 = 'php5-3.png',
  PORT_ENG = 'port-eng.png',
  PORTUGESE_1 = 'portugese-1.png',
  PORTUGESE_2 = 'portugese-2.png',
  PORTUGESE_3 = 'portugese-3.png',
  POSTGRESQL = 'postgresql.png',
  POSTSCRIPT_1 = 'postscript-1.png',
  POSTSCRIPT_2 = 'postscript-2.png',
  POSTSCRIPT_3 = 'postscript-3.png',
  PREFERREDFREELANCER_1 = 'preferredfreelancer-1.png',
  PROGRAMMER_1 = 'programmer_1.png',
  PROGRAMMER_2 = 'programmer_2.png',
  PROGRAMMER_3 = 'programmer_3.png',
  PROGRAMMER01 = 'programmer01.png',
  PROGRAMMER02 = 'programmer02.png',
  PROGRAMMER03 = 'programmer03.png',
  PROLOG_1 = 'prolog-1.png',
  PROLOG_2 = 'prolog-2.png',
  PROLOG_3 = 'prolog-3.png',
  PROTOTYPE_1 = 'prototype-1.png',
  PROTOTYPE_2 = 'prototype-2.png',
  PROTOTYPE_3 = 'prototype-3.png',
  PS_CS5_1 = 'ps-cs5-1.png',
  PS_CS5_2 = 'ps-cs5-2.png',
  PS_CS5_3 = 'ps-cs5-3.png',
  PS4_1 = 'PS4_1.png',
  PS4_2 = 'PS4_2.png',
  PS4_3 = 'PS4_3.png',
  PYTHON_V2_1 = 'Python_1.png',
  PYTHON_1 = 'python-1.png',
  PYTHON_2 = 'python-2.png',
  PYTHON_3 = 'python-3.png',
  QUARTERMASTER = 'quartermaster.png',
  QUICKBOOKS_1 = 'QuickBooks_1.png',
  RDF = 'rdf.png',
  REDIS_1 = 'redis-1.png',
  REDIS_2 = 'redis-2.png',
  REDIS_3 = 'redis-3.png',
  REG_EXP = 'reg_exp.png',
  REQ_ENG_1 = 'req-eng-1.png',
  REQ_ENG_2 = 'req-eng-2.png',
  REQ_ENG_3 = 'req-eng-3.png',
  REST = 'rest.png',
  ROR_1 = 'ror_1.png',
  ROR_2 = 'ror_2.png',
  ROR_3 = 'ror_3.png',
  RUBY_ON_RAILS = 'ruby-on-rails.png',
  RUBY = 'ruby.png',
  SCAV_HUNT_2012_1ST = 'scav-hunt-2012-1st.png',
  SCAV_HUNT_2012_2ND = 'scav-hunt-2012-2nd.png',
  SCAV_HUNT_2012_3RD = 'scav-hunt-2012-3rd.png',
  SCAV_HUNT_2012 = 'scav-hunt-2012.png',
  SCHEME_1 = 'scheme-1.png',
  SCHEME_2 = 'scheme-2.png',
  SCHEME_3 = 'scheme-3.png',
  SCRIPTLANCE = 'scriptlance.png',
  SED_AWK_1 = 'sed-awk-1.png',
  SED_AWK_2 = 'sed-awk-2.png',
  SED_AWK_3 = 'sed-awk-3.png',
  SEM_1 = 'SEM_1.png',
  SEM_2 = 'SEM_2.png',
  SEM_3 = 'SEM_3.png',
  SEMICONDUCTOR_ELECTRONICS_1 = 'semiconductor_electronics_1.png',
  SEMICONDUCTOR_ELECTRONICS_2 = 'semiconductor_electronics_2.png',
  SEMICONDUCTOR_ELECTRONICS_3 = 'semiconductor_electronics_3.png',
  SEMICONDUCTOR_ELECTRONICS = 'semiconductor_electronics.png',
  SEO_1 = 'SEO_1.png',
  SEO_2 = 'SEO_2.png',
  SEO_3 = 'SEO_3.png',
  SHAREPOINT_1 = 'sharepoint-1.png',
  SHAREPOINT_2 = 'sharepoint-2.png',
  SHAREPOINT_3 = 'sharepoint-3.png',
  SHAREPOINT2010_1 = 'sharepoint2010-1.png',
  SHAREPOINT2010_2 = 'sharepoint2010-2.png',
  SHAREPOINT2010_3 = 'sharepoint2010-3.png',
  SHELL_SCRIPT = 'shell-script.png',
  SHELLSCRIPT_1 = 'shellscript_1.png',
  SHELLSCRIPT_2 = 'shellscript_2.png',
  SHELLSCRIPT_3 = 'shellscript_3.png',
  SMALL_TALK_1 = 'small_talk_1.png',
  SMALLTALK = 'smalltalk.png',
  SOCIALENGINE = 'SocialEngine.png',
  SPAN_ENG = 'span-eng.png',
  SPANISH_1 = 'spanish-1.png',
  SPANISH_2 = 'spanish-2.png',
  SPANISH_3 = 'spanish-3.png',
  SQL_1 = 'SQL_1.png',
  SQL_2 = 'SQL_2.png',
  SQL_3 = 'SQL_3.png',
  SQL_SERVER_1 = 'sql-server-1.png',
  SQL_SERVER_2 = 'sql-server-2.png',
  SQL_SERVER_3 = 'sql-server-3.png',
  SQLITE_1 = 'sqlite-1.png',
  SQLITE_2 = 'sqlite-2.png',
  SQLITE_3 = 'sqlite-3.png',
  SQUID_1 = 'squid-1.png',
  SQUID_2 = 'squid-2.png',
  SQUID_3 = 'squid-3.png',
  STATISTICS = 'Statistics.png',
  SUBVERSION_1 = 'subversion-1.png',
  SUBVERSION_2 = 'subversion-2.png',
  SUBVERSION_3 = 'subversion-3.png',
  SWED_ENG = 'swed-eng.png',
  SWEDISH_1 = 'swedish-1.png',
  SWEDISH_2 = 'swedish-2.png',
  SWEDISH_3 = 'swedish-3.png',
  SYMBIAN_1 = 'Symbian_1.png',
  TCP_IP = 'tcp-ip.png',
  TELEPHONE_1 = 'telephone_1.png',
  TELEPHONE_2 = 'telephone_2.png',
  TELEPHONE_3 = 'telephone_3.png',
  THREEDMAX_1 = 'ThreeDMax_1.png',
  THREEDMAX_2 = 'ThreeDMax_2.png',
  THREEDMAX_3 = 'ThreeDMax_3.png',
  THREEDMAX_LEGACY_1 = '3dmax_1.png',
  TURKISH_1 = 'turkish-1.png',
  TURKISH_2 = 'turkish-2.png',
  TURKISH_3 = 'turkish-3.png',
  TURKISH_ENG = 'turkish-eng.png',
  TWITTER_DEVELOPING_1 = 'Twitter_Developing_1.png',
  TWITTER_API_1 = 'twitter-api-1.png',
  TWITTER_API_2 = 'twitter-api-2.png',
  TWITTER_API_3 = 'twitter-api-3.png',
  TYCOONTALK = 'tycoontalk.png',
  UK_ENGLISH_1 = 'uk_english1.png',
  UK_ENGLISH_2 = 'uk_english2.png',
  UKMEMBER = 'UKmember.png',
  UML_1 = 'uml-1.png',
  UML_2 = 'uml-2.png',
  UML_3 = 'uml-3.png',
  UNIX_1 = 'unix_1.png',
  UNIX_2 = 'unix_2.png',
  UNIX_3 = 'unix_3.png',
  US_ENG_1 = 'us_eng_1.png',
  US_ENG_2 = 'us_eng_2.png',
  US_ENG_3 = 'us_eng_3.png',
  USB_ELECT = 'usb-elect.png',
  VB1 = 'vb1.png',
  VB2 = 'vb2.png',
  VB3 = 'vb3.png',
  VB6_1 = 'vb6-1.png',
  VB6_2 = 'vb6-2.png',
  VB6_3 = 'vb6-3.png',
  VBSCRIPT_1 = 'vbscript-1.png',
  VBSCRIPT_2 = 'vbscript-2.png',
  VBSCRIPT_3 = 'vbscript-3.png',
  VIDEO_1 = 'video_1.png',
  VIDEO_2 = 'video_2.png',
  VIDEO_3 = 'video_3.png',
  VISUAL_BASIC_1 = 'Visual_Basic_1.png',
  VLSI_1 = 'VLSI_1.png',
  VLSI_2 = 'VLSI_2.png',
  VLSI_3 = 'VLSI_3.png',
  VOBIS_1 = 'vorbis-1.png',
  VOBIS_2 = 'vorbis-2.png',
  VOBIS_3 = 'vorbis-3.png',
  VPN_1 = 'vpn-1.png',
  VPN_2 = 'vpn-2.png',
  VPN_3 = 'vpn-3.png',
  VWORKER = 'vworker.png',
  WEB_1 = 'web_1.png',
  WEB_2 = 'web_2.png',
  WEB_3 = 'web_3.png',
  WINDOWS_PHONE_2 = 'windows-phone-2.png',
  WINDOWS_PHONE_3 = 'windows-phone-3.png',
  WINDOWS_PHONE = 'windows-phone.png',
  WINNER1 = 'winner1.png',
  WINNER2 = 'winner2.png',
  WINNER3 = 'winner3.png',
  WINSOCK2_1 = 'winsock2-1.png',
  WINSOCK2_2 = 'winsock2-2.png',
  WINSOCK2_3 = 'winsock2-3.png',
  WORDPRESS = 'WordPress.png',
  WSH_1 = 'wsh-1.png',
  WSH_2 = 'wsh-2.png',
  WSH_3 = 'wsh-3.png',
  XCODE_V3 = 'xcode-v3.png',
  XCODE_V4_1 = 'xcode-v4-1.png',
  XCODE_V4_2 = 'xcode-v4-2.png',
  XCODE_V4_3 = 'xcode-v4-3.png',
  XCODE1 = 'xcode1.png',
  XCODE2 = 'xcode2.png',
  XCODE3 = 'xcode3.png',
  XHTML_1 = 'xhtml-1.png',
  XHTML_2 = 'xhtml-2.png',
  XHTML_3 = 'xhtml-3.png',
  XML_1 = 'XML_1.png',
  XML_2 = 'XML_2.png',
  XML_3 = 'XML_3.png',
  XNA4_1 = 'xna4-1.png',
  XNA4_2 = 'xna4-2.png',
  XNA4_3 = 'xna4-3.png',
  XQUERY_1 = 'xquery-1.png',
  XQUERY_2 = 'xquery-2.png',
  XQUERY_3 = 'xquery-3.png',
  ZENCART_1 = 'Zencart_1.png',
  ZLECINIA = 'zlecinia.png',
}
